import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=4edae908&"
import script from "./CloseButton.vue?vue&type=script&lang=ts&"
export * from "./CloseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports